import { Checkbox, Typography, TextField, Icon, InputAdornment, IconButton, Tooltip, Button, CircularProgress } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { FIELDS, REPORT_CONDITIONS_IDS, REPORT_TYPES_IDS } from 'lib'
import React from 'react'
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import { uploadATSFileService } from 'lib/utils/api/upload'
import { DocumentContext } from 'context'
import { KeyboardDatePicker, DatePicker } from '@material-ui/pickers'
import { IDocumentALCOReportParams } from 'types'
import { FileUploadDialog } from 'components'

type ParamsType = "year-month" | "state-types-documentDate-receptionDate"

interface Props {
    type: ParamsType | string
    disabled: boolean
    reportKey: string
    onChange: (key: string, value: any) => void
    params: IDocumentALCOReportParams
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const mediumInputStyle = { width: "49%" }

const ReportParams = (props: Props) => {
    const { type, disabled, params, reportKey, onChange } = props
    const { documentTypes, historyTypes } = React.useContext(DocumentContext)
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)

    const uploadATSFile = async (files) => {
        setLoading(true)
        await uploadATSFileService(files[0].file)
        setLoading(false)
    }
    return (
        <div className="w-full flex flex-wrap pt-4">
            {
                type === "year-month" &&
                <div className="flex items-start w-full">
                    <DatePicker
                        views={["year", "month"]}
                        value={params[reportKey].yearMonth}
                        onChange={(date) => {
                            onChange(
                                reportKey,
                                { yearMonth: date }
                            )
                        }}
                        FormHelperTextProps={{ style: { margin: 0 } }}
                        style={{ ...mediumInputStyle, marginTop: 0 }}
                        emptyLabel={FIELDS.emptyDate.name}
                        inputVariant="outlined"
                        fullWidth
                        disabled={disabled}
                        // maxDate={filters.documentRange.end}
                        size="small"
                        helperText={FIELDS.yearMonth.name}
                        variant="inline"
                        format="MMMM/yyyy"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon fontSize="small" color="action">event</Icon>
                                </InputAdornment>
                            ),
                        }}
                    />
                    {
                        reportKey === "ats" &&
                        <div className="ml-4 pt-2">
                            {loading ?
                                <CircularProgress color="primary" size={27} thickness={12} />
                                :
                                <Button
                                    disableElevation
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => setOpen(true)}
                                    style={{ paddingLeft: "0.85rem" }}
                                >
                                    {"Subir formato excel"}
                                    <Icon fontSize="small" className="ml-1">
                                        upload
                                    </Icon>
                                </Button>
                            }
                            <FileUploadDialog
                                open={open}
                                onClose={() => setOpen(false)}
                                onAccept={(files) => uploadATSFile(files)}
                                singleFile
                                hideDescription
                            />
                        </div>
                        }
                </div>
            }
        </div>
    )
}

export default ReportParams
